import { create } from 'zustand';
import type { QuestionnaireAnswers } from '../types/questionnaire';

interface QuestionnaireState {
  currentQuestion: number;
  answers: QuestionnaireAnswers;
  setAnswer: (questionId: number, value: string | string[]) => void;
  toggleMultiAnswer: (questionId: number, value: string) => void;
  nextQuestion: () => void;
  prevQuestion: () => void;
  reset: () => void;
}

export const useQuestionnaireStore = create<QuestionnaireState>((set) => ({
  currentQuestion: 0,
  answers: {},

  setAnswer: (questionId, value) =>
    set((state) => ({
      answers: { ...state.answers, [questionId]: value },
    })),

  toggleMultiAnswer: (questionId, value) =>
    set((state) => {
      const current = (state.answers[questionId] as string[]) || [];
      const next = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { answers: { ...state.answers, [questionId]: next } };
    }),

  nextQuestion: () =>
    set((state) => ({ currentQuestion: Math.min(state.currentQuestion + 1, 5) })),

  prevQuestion: () =>
    set((state) => ({ currentQuestion: Math.max(state.currentQuestion - 1, 0) })),

  reset: () => set({ currentQuestion: 0, answers: {} }),
}));
